<template>
  <div>
    <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
    <listing-search-form
      :show-advanced="false"
      :fields="listingSearchFields"
      @click="onSearchClick"
      @change="onSearchResult"
    />
    <b-table
      v-if="0 !== listings.length"
      :fields="[
        {key: 'id', label: 'Id'},
        {key: 'name', label: 'Name'},
        {key: 'select', label: 'Select'},
      ]"
      :items="listings"
    >
      <template v-slot:cell(select)="data">
        <b-button v-on:click="onSelected(data)">
          Select
        </b-button>
      </template>

    </b-table>
  </div>
</template>

<script>
import {SearchField} from "@/services/SearchField";
import VueLoading from "vue-loading-overlay/src/js/Component";
import ListingSearchForm from "@/components/newsletter/Listing/ListingSearchForm";

export default {
  name: "SelectAudience",
  components: {
    VueLoading,
    ListingSearchForm,
  },
  data() {
    return {
      isLoading: false,
      listingSearchFields: [
        new SearchField()
          .setLabel('Name')
          .setKey('name')
          .setDescription('Filter name.')
          .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
        ,
      ],
      listings: [],
    }
  },
  methods: {
    onSearchResult(response) {
      let formattedResults = [];
      this.isLoading  = false;
      response.data.forEach(function (item) {
        formattedResults.push(
          {
            id: item.id,
            name: item.name,
            selected: false,
          }
        );
      });
      this.listings = formattedResults;
    },
    onSearchClick() {
      this.isLoading = true;
    },
    onSelected(listing) {
      this.$emit('selected', listing.item);
    }
  }
}
</script>

<style scoped>

</style>
